module.exports = __webpack_public_path__ + "img/logo-rci.3859c002.png";